import { CompanyContacts } from "./CompanyContacts";
import { Entity } from "./Entity.abstract";

export class NPSEntity extends Entity {
    constructor({
        _id,
        period,
        companiesRatings,
        promotersTotal,
        passivesTotal,
        detractorsTotal,
        npsScore
    }) {
        super({
            _id,
            period,
            companiesRatings,
            promotersTotal,
            passivesTotal,
            detractorsTotal,
            npsScore
        });
        this.setRelationedEntities(companiesRatings);
    }

    setRelationedEntities(companiesRatings) {
        if (!companiesRatings) return;
        this.props.companiesRatings = companiesRatings.map((company) => {
            const companyContacts = new CompanyContacts(company.company);
            companyContacts.removeContactsWithoutNPS();
            return companyContacts;
        });
    }

    hasCompanies() {
        return this.props.companiesRatings?.length > 0;
    }

    getKPIS() {
        const ratingsTotal =
            this.props.companiesRatings?.reduce((acc, company) => {
                const allRatings = company.getAllRatings();
                return acc + allRatings?.length || 0;
            }, 0) || 0;
        return {
            promotersTotal: this.props.promotersTotal || 0,
            passivesTotal: this.props.passivesTotal || 0,
            detractorsTotal: this.props.detractorsTotal || 0,
            npsScore: this.props.npsScore || 0,
            companiesTotal: this.props.companiesRatings?.length || 0,
            ratingsTotal
        };
    }

    getRecommendations() {
        return this.props.companiesRatings?.reduce((acc, company) => {
            const recommendations = company.getRecommendations();
            if (recommendations?.length > 0) {
                acc.push(...recommendations);
            }
            return acc;
        }, []);
    }
}
